/**
 * Admin image cache hooks using TanStack Query
 */

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { adminApi } from '../api/adminApi';
import type { ImageCacheEntry } from '../schemas/admin.schemas';

const IMAGE_CACHE_KEY = ['admin-image-cache'];

export function useAdminImageCache() {
  return useQuery<ImageCacheEntry[]>({
    queryKey: IMAGE_CACHE_KEY,
    queryFn: () => adminApi.listImageCache(),
  });
}

export function useDeleteImageCache() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (cacheId: string) => adminApi.deleteImageCacheEntry(cacheId),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: IMAGE_CACHE_KEY });
    },
  });
}
